module.exports = __webpack_public_path__ + "img/acc_b.0e58b900.png";